<template>
  <div class="index">
    <nav-top :nav-type="4" />
    <div class="header">
      <div class="index_menu flex_around">
          <div @click="homeMenuLink(1)" :class="type === 1 ? 'index_menu_on' :'' " class="flex_center">
            홈
          </div>
          <div @click="homeMenuLink(2)" :class="type === 2 ? 'index_menu_on' :'' " class="flex_center">
            동영상
          </div>
          <div @click="homeMenuLink(3)" :class="type === 3 ? 'index_menu_on' :'' " class="flex_center">
            <div>
              LIVE
            </div>
          </div>
      </div>
    </div>

    <template v-if="type === 1">
      <menu-home></menu-home>
    </template>
    <template v-else-if="type === 2">
      <menu-live></menu-live>
    </template>
    <template v-else-if="type === 3">
      <menu-video></menu-video>
    </template>

    <div class="home_footer">
      <div class="home_footer_logo">
        <img src="@/assets/icon/logo_4.png"/>
      </div>
    </div>

  </div>


</template>

<script>
  import NavTop from '@/components/navTop'
  import menuHome from '@/views/Main/Home/Home'
  import menuLive from '@/views/Main/Live/Live'
  import menuVideo from '@/views/Main/Video/Video'

export default {
    name: 'index',
  components: {
    menuHome ,
    NavTop ,
    menuLive ,
    menuVideo
  }
  ,data(){
      return {
        type:1
      }
  }
  ,mounted(){
    this.$eventpopup({
      imgURL : require('@/assets/data/event_1.png')
      ,linkURL :'http://www.naver.com'
    });
  }
  ,methods:{
      homeMenuLink(type){
        this.type = type;
      }
  }
}
</script>

<style scoped>

  .index {
    min-height: 100%;position: relative;
  }
  .header {
    padding: 1.667rem 0 0 0;

  }
  .index_menu {
    height: 1.389rem;
    background-color: #F8F7F4;
  }
  .index_menu_on {
      color: #F15929;
  }

  .index_menu > div {
    width: 33%;
    text-align: center;
    height: 100%;
  }

  .index_menu .index_menu_on > div:last-child {
    background-color: #F15929;
    width: 1.333rem;
    margin: auto;
    color: #fff;
    padding: 0.139rem 0;
    -webkit-border-radius: 0.069rem;
    -moz-border-radius: 0.069rem;
    border-radius: 0.139rem
  }

  .index_menu > div > div:last-child {
    background-color: #E3E3E3;
    width: 1.333rem;
    margin: auto;
    padding: 0.139rem 0;
    -webkit-border-radius: 0.069rem;
    -moz-border-radius: 0.069rem;
    border-radius: 0.139rem
  }

  .home_footer {
    width: 100%;
    height: 3rem;
  }

  .home_footer_logo {
    width: 100%;
    padding: 0.583rem 0;
    text-align: center;
    border-top: 1px solid #C8C8C8;
    position: absolute;
    bottom: 0;
  }
  .home_footer_logo img {
    width: 2.389rem;
    height: 1.035rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/Main/index.vue